//
window.vW = 1440;
window.vH = 790;

//
window.$html = document.querySelector('html');
window.$app = document.querySelector('#app');
window.$head = document.querySelector('head');

//
window.WH = Math.min( window.innerHeight, $html.getBoundingClientRect().height );
window.WW = window.innerWidth;

//
window.RES = Math.min( window.devicePixelRatio, 1.75 );


//=========================
// RESET
//=========================
window.WEBGL = null;
window.styleMouse = { body : null };
// window.styleSlider = { body : null };
window.styleInviewImage = null;
window.styleInviewVideo = null;


//
const $detectVideo = document.querySelector('.c-detect-video');
const videoPromise = $detectVideo.play();
window.isLowPowerMode = false;
$html.dataset.lowPower = false;
videoPromise.catch((error) =>{
	isLowPowerMode = true;
	$html.dataset.lowPower = true;
});


//
// DETECT.legacy = true;


//
window.loadControl = {
	ga : {
		d : getParam('pf-ga-d') ? Number( getParam('pf-ga-d') ) : 3000,
		s : getParam('pf-ga-s') ? Number( getParam('pf-ga-s') ) : 3000,
	},
	font : {
		d : getParam('pf-font-d') ? Number( getParam('pf-font-d') ) : 7000
	},
	page : {
		d : getParam('pf-page-d') ? Number( getParam('pf-page-d') ) : 0,
		s : getParam('pf-page-s') ? Number( getParam('pf-page-s') ) : 500,
	},
	slider : {
		d : getParam('pf-slider-d') ? Number( getParam('pf-slider-d') ) : 5000,
		s : getParam('pf-slider-s') ? Number( getParam('pf-slider-s') ) : 1000,
	},
	image : {
		d : getParam('pf-image-d') ? Number( getParam('pf-image-d') ) : 2000,
		s : getParam('pf-image-s') ? Number( getParam('pf-image-s') ) : 2000,
	},
	video : {
		d : getParam('pf-video-d') ? Number( getParam('pf-video-d') ) : 5000,
		s : getParam('pf-video-s') ? Number( getParam('pf-video-s') ) : 3000,
	}
}



//
$html.style.setProperty('--vh', WH/100 + 'px' );
window.addEventListener('load' , e =>{
	onLoad();
	$html.style.setProperty('--vh', WH/100 + 'px' );
});



// メモリーに登録
window.PRE_RENDER_WEBGL = true;

/*
 ██████╗ ███╗   ██╗██╗      ██████╗  █████╗ ██████╗ 
██╔═══██╗████╗  ██║██║     ██╔═══██╗██╔══██╗██╔══██╗
██║   ██║██╔██╗ ██║██║     ██║   ██║███████║██║  ██║
██║   ██║██║╚██╗██║██║     ██║   ██║██╔══██║██║  ██║
╚██████╔╝██║ ╚████║███████╗╚██████╔╝██║  ██║██████╔╝
 ╚═════╝ ╚═╝  ╚═══╝╚══════╝ ╚═════╝ ╚═╝  ╚═╝╚═════╝ 
*/
window.onLoad = ()=>{

	//
	$html.classList.add('is-ld');

	//
	pageTransition.once();

	//
	if( WEBGL ) WEBGL.once();
	if( RESOURCE ) RESOURCE.once();

	//
	styleAspect.onInit();
	styleInview.onInit();
	if( styleInviewImage ) styleInviewImage.onInit();
	if( styleInviewVideo ) styleInviewVideo.onInit();
	styleCopy.onInit();
	// styleSlider.onInit();
	styleFilter.onInit();
	styleToggle.onInit();
	styleText.onInit();
	styleMail.onInit();
	styleCss.onInit();
	stylePopup.onInit();

	//
	pageScroll.onInit();

	//
	if( WEBGL ){
		WEBGL.dom.onInit();
		WEBGL.logo.onInit();
	}

	//
	gsap.ticker.add(( t )=>{
		tick( t );
	});

	//
	$html.classList.remove('is-ld-b');
	setTimeout( () => {
		PRE_RENDER_WEBGL = false;
		setTimeout( () => {
			onSplash();
		}, 100 );
	}, 200 );

}









/*
████████╗██╗ ██████╗██╗  ██╗
╚══██╔══╝██║██╔════╝██║ ██╔╝
   ██║   ██║██║     █████╔╝ 
   ██║   ██║██║     ██╔═██╗ 
   ██║   ██║╚██████╗██║  ██╗
   ╚═╝   ╚═╝ ╚═════╝╚═╝  ╚═╝
*/
window.GLOBAL_TIME = 0;
window.tick = ( t ) =>{

	//
	if( styleMouse.body ) styleMouse.body.raf();
	// if( styleSlider.body ) styleSlider.body.raf();

	//
	pageScroll.onUpdate();
	if( pageScroll.body ) pageScroll.body.raf( t * 1000 );

	//
	if( !DETECT.reduced ) GLOBAL_TIME++;
	if( WEBGL ) WEBGL.onRender();

}










/*
 ██████╗ ███╗   ██╗██████╗ ███████╗███████╗██╗███████╗███████╗
██╔═══██╗████╗  ██║██╔══██╗██╔════╝██╔════╝██║╚══███╔╝██╔════╝
██║   ██║██╔██╗ ██║██████╔╝█████╗  ███████╗██║  ███╔╝ █████╗  
██║   ██║██║╚██╗██║██╔══██╗██╔══╝  ╚════██║██║ ███╔╝  ██╔══╝  
╚██████╔╝██║ ╚████║██║  ██║███████╗███████║██║███████╗███████╗
 ╚═════╝ ╚═╝  ╚═══╝╚═╝  ╚═╝╚══════╝╚══════╝╚═╝╚══════╝╚══════╝
*/
let resizeTimerFirst;
let resizeTimerSecond;
let resizeTimerThird;
window.onResize = ()=>{

	//
	WH = Math.min( window.innerHeight, $html.getBoundingClientRect().height );
	WW = window.innerWidth;

	//
	$html.style.setProperty('--vh', window.innerHeight/100 + 'px' );
	// $root.textContent = ':root {--vh:'+ WH/100 +'px;}';

	//
	clearTimeout( resizeTimerFirst );
	resizeTimerFirst = setTimeout(()=>{
		if( pageScroll ) pageScroll.onResize();
	}, 200);

	//
	clearTimeout( resizeTimerSecond );
	resizeTimerSecond = setTimeout(()=>{
	}, 400);

	//
	clearTimeout( resizeTimerThird );
	resizeTimerThird = setTimeout(()=>{
		if( WEBGL ) WEBGL.onResize();
	}, 600);

}

//
if( !DETECT.device.any ){
	window.addEventListener('resize' , e =>{
		onResize();
	});
} else {
	window.addEventListener("orientationchange", function() {
		location.reload();
	});
}








/*
 ██████╗ ███╗   ██╗███████╗██████╗ ██╗      █████╗ ███████╗██╗  ██╗
██╔═══██╗████╗  ██║██╔════╝██╔══██╗██║     ██╔══██╗██╔════╝██║  ██║
██║   ██║██╔██╗ ██║███████╗██████╔╝██║     ███████║███████╗███████║
██║   ██║██║╚██╗██║╚════██║██╔═══╝ ██║     ██╔══██║╚════██║██╔══██║
╚██████╔╝██║ ╚████║███████║██║     ███████╗██║  ██║███████║██║  ██║
 ╚═════╝ ╚═╝  ╚═══╝╚══════╝╚═╝     ╚══════╝╚═╝  ╚═╝╚══════╝╚═╝  ╚═╝
 */

window.IS_SPLASHED = false;
window.onSplash = () =>{

	//
	$html.classList.add('is-ld-a');

	//
	pageTransition.onEnterLogo({
		s : pageTransition.anim.enter.s,
		e : pageTransition.anim.enter.e,
		d : 0,
		g : pageTransition.stagger
	});
	pageTransition.onEnterMask({
		s : pageTransition.anim.enter.s,
		e : pageTransition.anim.enter.e,
		d : 0,
		g : pageTransition.stagger
	});

	//
	if( WEBGL ){
		// WEBGL.logo.onEnterAnim();
		WEBGL.logo.onEnterAnim({
			s : pageTransition.anim.enter.s * 0.8,
			g : pageTransition.stagger * 0.7,
			d : 0,
			e : 'power2.out'
		});
	}

}



























